export const unbookableWithReason = (bookable: boolean) => {
  if (bookable !== false) {
    return undefined
  }

  return "Sorry, this listing isn't currently bookable."
}
